import { gql } from 'graphql-request';
import { useRequestGQLQuery } from 'src/services/grapqlQueries/useGraphQLQuery';

export const GET_LOANAPP_BY_LOAN_ROLE_ACCOUNT = gql`query get_loans_by_account($object_meta:jsonb) {
  declarations(where: {object_meta: {_contains: $object_meta}}) {
    id
    object_meta
  }
  loanapp_roles(where: {object_meta: {_contains: $object_meta}}, order_by: {created_at: asc}) {
    id
    loanapp {
      id
      type_of_loan
      sub_type_of_loan
      created_at
      properties(where: {object_meta: {_contains: $object_meta}}) {
        id
        address
        object_meta
      },
  
      loanapp_roles{
        id
        object_meta
        metadata
        borrowers {
          id
          profile
          addresses
          object_meta
        },
        businesses {
          id
          business_name
          metadata
          address
        },
        lending_terms {
          id
          terms
          object_meta
        },
        loan_statuses{
          id
          status
       }
      }
    }
  }
}`;


export const GET_BORROWERS_BY_ACCOUNT_ID = gql`query get_loans_by_account($object_meta:jsonb) {
  borrowers(where: {object_meta: {_contains: $object_meta}}, order_by: {created_at: asc},limit:1) {
        profile
        addresses
      }
  }`;

export const GQLGetLoanAppByNamespaceRole = async (variables: any) => {
  const result = await useRequestGQLQuery(GET_LOANAPP_BY_LOAN_ROLE_ACCOUNT, variables);
  return result;
};


export const GQLGetBusiness = async (variables: any) => {
  const result = await useRequestGQLQuery(GET_LOANAPP_BY_EIN, variables);
  return result;
};

const GET_LOANAPP_BY_EIN = gql`query get_business_by_ssn($ein:[String!],$objectMeta:jsonb) {
  business(where: {tin_ein_ssn: {_in: $ein}, _and:{object_meta:{_contains: $objectMeta}}}){
     business_name
      tin_ein_ssn
      object_meta
      created_at
    loanapp_role{
      loanapp{
        id
        type_of_loan
      }
      loan_statuses{
        id
        status
      }
    }
  }
}`


export const GET_MORTGAGE_LOAN_APP_BY_SSN = gql`borrowers(where: {profile: {_contains: $profile}, _and:{object_meta:{_contains: $objectMeta}}},limit: 10){
  profile
   object_meta
   created_at
 loanapp_role{
   loanapp{
     id
     type_of_loan
     properties{
       object_meta
     }
   }
   loan_statuses{
     id
     status
   }
 }
}`

const MORTGAGE_RESOURCES = `loanapps(where: {id: {_eq: $loanAppId}}) {
  id
  type_of_loan
  object_meta
}
borrowers(where: {object_meta: {_contains: $objectMeta}}) {
  id
  loanrole_id
  object_meta
  updated_at
  profile
  addresses
  military_service
  housing_expense
  metadata
}
bank_accounts(where: {object_meta: {_contains: $objectMeta}}) {
  id
  accounts
  object_meta
  created_at
  updated_at
  metadata
  depository
}
credit_reports(where: {object_meta: {_contains: $objectMeta}}) {
  id
  object_meta
  created_at
  updated_at
  metadata
  scores
  applicants
  details
}
declarations(where: {object_meta: {_contains: $objectMeta}}) {
  id
  consents
  object_meta
  created_at
}
employments(where: {object_meta: {_contains: $objectMeta}}) {
  id
  history
  object_meta
  created_at
  updated_at
  status
  detail
  metadata
}
loan_status(where: {object_meta: {_contains: $objectMetaByLoanId}}) {
  id
  loanrole_id
  object_meta
  status
  metadata
  loan_status_identifier
  created_at
  updated_at
}
lending_terms(where: {object_meta: {_contains: $objectMetaByLoanId}}) {
  id
  loanrole_id
  object_meta
  terms
  case_detail
  metadata
  created_at
  updated_at
}
properties(where: {object_meta: {_contains: $objectMetaByLoanId}}) {
  id
  address
  object_meta
  created_at
  loanapp_id
  metadata
  details
  purpose
  title
  source_of_downpayment
}
team_members(where: {metadata: {_contains: $metadata}}) {
  id
  object_meta
  metadata
  created_at
  updated_at
  status
  team_id
  member_owner_id
}
real_estate_assets(where: {object_meta: {_contains: $objectMeta}}) {
  id
  object_meta
  address
  owned_property_detail
  property_detail
  metadata
  created_at
  updated_at
  project
}
 workflow_intents(where: {object_meta: {_contains: $objectMeta}}) {
  id
  object_meta
  intents
  metadata
  created_at
  updated_at
}
collaterals(where: {object_meta: {_contains: $objectMeta}}) {
  id
  object_meta
  collateral_information
  asset_details
  owner_details
  collateral_security
  insurance_details
  metadata
  address
  loanapp_role_id
  created_at
  updated_at
}
loanapp_roles(where: {loanapp_id: {_eq: $loanAppId}}) {
  id
  object_meta
  metadata
  created_at
  updated_at
}
business(where: {object_meta: {_contains: $objectMeta}}) {
  id
  loanrole_id
  object_meta
  updated_at
  business_name
  type_of_business
  trademark_name
  tin_ein_ssn
  address
  email
  phone
  metadata
  primary_contact
  average_monthly_payroll
  number_of_employees
  purpose_of_loan
  owners,
  authorized_peoples
  business_information
}
`;

const NOTMORTGAGE_RESOURCES = `loanapps(where: {id: {_eq: $loanAppId}}) {
  id
  type_of_loan
  object_meta
}
business(where: {object_meta: {_contains: $objectMeta}}) {
  id
  loanrole_id
  object_meta
  updated_at
  business_name
  type_of_business
  trademark_name
  tin_ein_ssn
  address
  email
  phone
  metadata
  primary_contact
  average_monthly_payroll
  number_of_employees
  purpose_of_loan
  owners,
  authorized_peoples
  business_information
}
declarations(where: {object_meta: {_contains: $objectMeta}}) {
  id
  consents
  object_meta
  created_at
}
loan_status(where: {object_meta: {_contains: $objectMetaByLoanId}}) {
  id
  loanrole_id
  object_meta
  status
  metadata
  loan_status_identifier
  created_at
  updated_at
}
 workflow_intents(where: {object_meta: {_contains: $objectMeta}}) {
  id
  object_meta
  intents
  metadata
  created_at
  updated_at
}
team_members(where: {object_meta: {_contains: $metadata}}) {
  id
  object_meta
  metadata
  created_at
  updated_at
  status
  team_id
  member_owner_id
}
properties(where: {object_meta: {_contains: $objectMetaByLoanId}}) {
  id
  address
  object_meta
  created_at
  loanapp_id
  metadata
  details
}`

export const DASHBOARD_RESOURCES = `
bank_accounts(where: {object_meta: {_contains: $objectMeta}}) {
  id
  accounts
  object_meta
  created_at
  updated_at
  metadata
  depository
}
credit_reports(where: {object_meta: {_contains: $objectMeta}}) {
  id
  object_meta
  created_at
  updated_at
  metadata
  scores
  applicants
  details
}
real_estate_assets(where: {object_meta: {_contains: $objectMeta}}) {
  id
  object_meta
  address
  owned_property_detail
  property_detail
  metadata
  created_at
  updated_at
  project
}
monthly_incomes(where: {object_meta: {_contains: $objectMeta}}) {
  id
  object_meta
  wages
  deductions
  status
  multiplier
  employment_income_indicator
  income_type
  income_type_other_description
  depository
  metadata
  created_at
  updated_at
}`;


const GET_TEAM_MEMBERS = `query get_team_member_by_accountId($teamId:bigint) {
  team_members(where: {team_id: {_eq: $teamId}}) {
    id
    object_meta
    metadata
    created_at
    updated_at
    status
    team_id
    member_owner_id
  }
}`

const defaultLoanResourcesQuery = (describeQuery: string) => {
  return `query get_loans_resources_by_loanid($objectMeta:jsonb) {
    ${describeQuery}
  }`
}

const loanResourcesDescribeQuery = (hasMortgage: boolean) => {
  const loanQuery = hasMortgage ? MORTGAGE_RESOURCES : NOTMORTGAGE_RESOURCES
  return `query get_loans_resources_by_loanid(
    $objectMeta:jsonb,
    $loanAppId: bigint,
    $objectMetaByLoanId:jsonb,
    $metadata:jsonb) {
    ${loanQuery}
  }`
}

export const GQLDescribeLoanDetails = async (variables: {
  objectMeta: {
    namespace: string;
    owner_references: [{ uid: string }]
  };
  loanAppId: string;
  objectMetaByLoanId: {
    namespace: string;
    owner_references: [{ uid: string }]
  };
  metadata: {
    loan_id: string;
  }
}, hasMortgage: boolean, describeQuery?: any) => {
  const query = describeQuery ?
    defaultLoanResourcesQuery(describeQuery) :
    loanResourcesDescribeQuery(hasMortgage);
  const result = await useRequestGQLQuery(query, variables);
  return result;
};

export const GQLDescribeTeamMembers = async (variables: {
  metadata: {
    loan_id: string;
  }
}) => {
  const result = await useRequestGQLQuery(GET_TEAM_MEMBERS, variables);
  return result;
};

export const GET_BUSINESS = `query get_business_by_loanid($objectMeta:jsonb) {
  business(where: {object_meta: {_contains: $objectMeta}}){
     id
     loanrole_id
     type_meta
     object_meta
     business_name
     type_of_business
     trademark_name
     tin_ein_ssn
     email
     phone
     address
     primary_contact
     average_monthly_payroll
     number_of_employees
     purpose_of_loan
     owners
     metadata
     updated_at
     created_at
  }
}`
